import dateFormatNames from '../cldr/date-format-names';
import dateNameType from './date-name-type';

export default function formatNames(locale, type, formatLength, standAlone, lower) {
    return dateFormatNames(locale, {
        type: type,
        nameType: dateNameType(formatLength),
        standAlone: standAlone,
        lower: lower
    });
}


//////////////////
// WEBPACK FOOTER
// ./~/@telerik/kendo-intl/dist/es/dates/format-names.js
// module id = 397
// module chunks = 93